/**
 * Auth client — `POST /api/auth/login` against the Rust BFF (Phase 2b).
 *
 * Returns `{ token, organization, user }`. The login screen wires directly to
 * {@link login}; the returned **user token** is the single credential the rest
 * of the app uses: `Authorization: Bearer <token>` on `/api/chat`, and the
 * MapLibre `transformRequest` for `*.proximi.fi` tiles/glyphs/features.
 *
 * Targets {@link BFF_BASE} (`/api` by default → Vite dev proxy → Rust server),
 * not the public Proximi.io gateway: the BFF performs the upstream login and
 * relays the token, keeping the SPA same-origin and CORS-free.
 */
import { request, BFF_BASE } from "./client";
import {
  loginRequestSchema,
  loginResponseSchema,
  type LoginRequest,
  type LoginResponse,
} from "./types";

export async function login(
  credentials: LoginRequest,
  signal?: AbortSignal,
): Promise<LoginResponse> {
  const body = loginRequestSchema.parse(credentials);
  return request("/auth/login", {
    method: "POST",
    body,
    schema: loginResponseSchema,
    base: BFF_BASE,
    signal,
  });
}
